/**
 * AT スタンドアロン・ヒーローカルーセル（セクション単位・複数可）
 */
(function () {
  'use strict';

  var ROOT = '[data-at-standalone-hero]';
  var DATA = '[data-at-sh-data]';
  var TRACK = '[data-at-sh-track]';
  var SLIDE = '[data-at-sh-slide]';
  var CONTROLS = '[data-at-sh-controls]';

  function parseJson(el) {
    if (!el || !el.textContent) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function pauseAllVideos(root) {
    root.querySelectorAll('video').forEach(function (v) {
      v.pause();
    });
  }

  function playSlideVideos(root, index) {
    var slides = root.querySelectorAll(SLIDE);
    var slide = slides[index];
    if (!slide) return;
    slide.querySelectorAll('video').forEach(function (v) {
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    });
  }

  function initOne(root) {
    var dataEl = root.querySelector(DATA);
    var slideData = parseJson(dataEl);
    var track = root.querySelector(TRACK);
    if (!track) return;

    var slides = root.querySelectorAll(SLIDE);
    var slideCount = slides.length;
    if (slideCount === 0) return;

    var autoplaySec = parseInt(root.getAttribute('data-autoplay-seconds'), 10);
    if (isNaN(autoplaySec) || autoplaySec < 1) autoplaySec = 5;
    var autoplayDelay = autoplaySec * 1000;

    var controlsWrapper = root.querySelector(CONTROLS);
    var titleEl = root.querySelector('[data-at-sh-title]');
    var descriptionEl = root.querySelector('[data-at-sh-description]');
    var linkEl = root.querySelector('[data-at-sh-link]');
    var logoEl = root.querySelector('[data-at-sh-logo]');
    var textboxSurface = root.querySelector('.at-sh-textbox-surface');

    var defaultTitle = (titleEl && titleEl.getAttribute('data-default-text')) || '';
    var defaultDescription =
      (descriptionEl && descriptionEl.getAttribute('data-default-text')) || '';
    var defaultLink = (linkEl && linkEl.getAttribute('data-default-href')) || '#service';
    var defaultMoreButton = (linkEl && linkEl.getAttribute('data-default-text')) || '';

    var currentIndex = 0;
    var autoplayTimer = null;
    var isTransitioning = false;

    function updateContent(index) {
      var data = slideData[index];
      if (!data) return;

      if (titleEl) {
        var titleRaw =
          data.title && String(data.title).trim()
            ? data.title
            : defaultTitle;
        titleEl.textContent = titleRaw;
      }

      if (descriptionEl) {
        var raw =
          data.description && String(data.description).trim()
            ? data.description
            : defaultDescription;
        descriptionEl.innerHTML = escapeHtml(raw).replace(/\n/g, '<br>');
      }

      if (linkEl) {
        var href =
          data.link && String(data.link).trim() ? data.link : defaultLink;
        linkEl.setAttribute('href', href);
        var moreBtn =
          data.moreButton && String(data.moreButton).trim()
            ? data.moreButton
            : defaultMoreButton;
        linkEl.textContent = moreBtn;
      }

      if (logoEl) {
        logoEl.style.display = data.hideLogo === true ? 'none' : '';
      }
    }

    function goToSlide(index) {
      if (isTransitioning) return;
      isTransitioning = true;
      currentIndex = ((index % slideCount) + slideCount) % slideCount;
      track.style.transform = 'translateX(-' + currentIndex * 100 + '%)';

      var searchRoot = controlsWrapper || root;
      var dots = searchRoot.querySelectorAll('.at-sh-dots button');
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
        dot.setAttribute('aria-selected', i === currentIndex);
      });

      updateContent(currentIndex);
      pauseAllVideos(root);
      playSlideVideos(root, currentIndex);

      resetAutoplay();
      setTimeout(function () {
        isTransitioning = false;
      }, 500);
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      if (slideCount <= 1) return;
      autoplayTimer = setInterval(nextSlide, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function resetAutoplay() {
      startAutoplay();
    }

    var searchRoot = controlsWrapper || root;
    var prevBtn = searchRoot.querySelector('.at-sh-arrow--prev');
    var nextBtn = searchRoot.querySelector('.at-sh-arrow--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
      prevBtn.setAttribute('aria-label', '前のスライド');
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
      nextBtn.setAttribute('aria-label', '次のスライド');
    }

    searchRoot.querySelectorAll('.at-sh-dots button').forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goToSlide(i);
      });
      dot.setAttribute('aria-label', 'スライド ' + (i + 1) + ' / ' + slideCount);
    });

    var touchStartX = 0;
    root.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    root.addEventListener(
      'touchend',
      function (e) {
        var touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        var threshold = 50;
        if (Math.abs(diff) > threshold) {
          if (diff > 0) nextSlide();
          else prevSlide();
        }
      },
      { passive: true }
    );

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    /* テーマ CSS が padding を潰しても最終的に上書き（setProperty + important はスタイルシートより強い） */
    if (textboxSurface) {
      var padDesk = root.getAttribute('data-at-sh-text-pad-d') || '24px 36px';
      var padMob = root.getAttribute('data-at-sh-text-pad-m') || '14px 22px';
      var padRaf = null;
      function applyTextboxPadding() {
        var narrow = window.matchMedia('(max-width: 768px)').matches;
        textboxSurface.style.setProperty('padding', narrow ? padMob : padDesk, 'important');
        textboxSurface.style.setProperty('box-sizing', 'border-box', 'important');
      }
      function applyTextboxPaddingRaf() {
        if (padRaf != null) cancelAnimationFrame(padRaf);
        padRaf = requestAnimationFrame(function () {
          padRaf = null;
          applyTextboxPadding();
        });
      }
      applyTextboxPadding();
      window.addEventListener('resize', applyTextboxPaddingRaf);
    }

    goToSlide(0);
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
